import { useEffect, useState } from 'react';
import { authzApi } from '../../api/authz';

type AuditEntry = {
  id: string;
  actor_id: string;
  user_id?: string;
  action: string;
  resource?: string;
  outcome: string;
  created_at: string;
};

export function PermissionAuditPage() {
  const [entries, setEntries] = useState<AuditEntry[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void authzApi.listAudit(100).then((items) => setEntries(items as AuditEntry[])).catch((err) => setError(String(err)));
  }, []);

  return (
    <div className="mx-auto max-w-5xl p-6">
      <h1 className="text-2xl font-semibold text-slate-900">Permission audit</h1>
      <p className="mt-1 text-sm text-slate-600">Authorization checks and permission changes.</p>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}

      <div className="mt-6 overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table className="min-w-full text-sm">
          <thead className="border-b border-slate-200 bg-slate-50 text-left">
            <tr>
              <th className="px-4 py-3 font-medium">Time</th>
              <th className="px-4 py-3 font-medium">User</th>
              <th className="px-4 py-3 font-medium">Action</th>
              <th className="px-4 py-3 font-medium">Resource</th>
              <th className="px-4 py-3 font-medium">Outcome</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id} className="border-b border-slate-100">
                <td className="px-4 py-3 text-slate-600">{new Date(e.created_at).toLocaleString()}</td>
                <td className="px-4 py-3">{e.user_id || e.actor_id || '—'}</td>
                <td className="px-4 py-3">{e.action}</td>
                <td className="px-4 py-3">{e.resource || '—'}</td>
                <td className="px-4 py-3">
                  <span className={e.outcome === 'allow' ? 'text-green-700' : 'text-red-700'}>{e.outcome}</span>
                </td>
              </tr>
            ))}
            {entries.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-slate-600">No audit entries yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
